import React, { useEffect } from 'react';
import { Box, Flex, Text, Grid, VStack, HStack, Link, Divider } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleNav = (path) => {
    if (path.includes('#')) {
      navigate('/');
      setTimeout(() => {
        document.getElementById(path.split('#')[1])?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (window.gapi) {
      window.gapi.ytsubscribe && window.gapi.ytsubscribe.go();
    }
  }, []);

  return (
    <Box
      as="footer"
      bg="#0a0f1a"
      borderTop="1px solid rgba(0,195,255,0.1)"
      pt={16}
      pb={6}
      px="5%"
    >
      <Grid
        templateColumns={{ base: '1fr', sm: '1fr 1fr', lg: '2fr 1fr 1fr 1fr' }}
        gap={10}
        mb={12}
      >
        {/* Brand */}
        <VStack align="flex-start" gap={4}>
          <Flex align="center" gap={2}>
            <Box w="9px" h="9px" bg="#00c3ff" borderRadius="50%" boxShadow="0 0 6px rgba(0,195,255,0.7)" />
            <Text fontFamily="'Fraunces', serif" fontWeight={900} fontSize="1.3rem">
              Tech<Text as="span" color="#00c3ff">Bheekaran</Text>
            </Text>
          </Flex>
          <Text color="#6b7fa0" fontSize="0.88rem" lineHeight={1.8} maxW="260px">
            India's honest tech voice. Unbiased reviews, real buying guides, and the best deals — tested for Indian users.
          </Text>
          <HStack gap={3}>
            {['📺', '📸', '🐦'].map((icon, i) => (
              <Link
                key={i}
                href="https://www.youtube.com/@techbheekaran"
                target="_blank"
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="36px"
                h="36px"
                bg="rgba(0,195,255,0.07)"
                borderRadius="8px"
                border="1px solid rgba(0,195,255,0.15)"
                fontSize="0.9rem"
                transition="all 0.2s"
                _hover={{ bg: 'rgba(0,195,255,0.15)', borderColor: '#00c3ff' }}
              >
                {icon}
              </Link>
            ))}
          </HStack>
        </VStack>

        {/* Quick Links */}
        <VStack align="flex-start" gap={3}>
          <Text fontFamily="'Fraunces', serif" fontWeight={700} mb={1}>Navigate</Text>
          {[
            { label: 'Home', path: '/' },
            { label: 'Videos', path: '/videos' },
            { label: 'Blog', path: '/articles' },
            { label: 'Deals', path: '/deals' },
            { label: 'Resources', path: '/docs' },
          ].map(link => (
            <Text
              key={link.label}
              color="#6b7fa0"
              fontSize="0.88rem"
              cursor="pointer"
              transition="color 0.2s"
              _hover={{ color: '#00c3ff' }}
              onClick={() => handleNav(link.path)}
            >
              {link.label}
            </Text>
          ))}
        </VStack>

        {/* Categories */}
        <VStack align="flex-start" gap={3}>
          <Text fontFamily="'Fraunces', serif" fontWeight={700} mb={1}>Categories</Text>
          {['Smartphones', 'Laptops', 'Audio', 'Smartwatches', 'Cameras'].map(cat => (
            <Text
              key={cat}
              color="#6b7fa0"
              fontSize="0.88rem"
              cursor="pointer"
              transition="color 0.2s"
              _hover={{ color: '#00c3ff' }}
              onClick={() => { navigate('/articles'); window.scrollTo({ top: 0 }); }}
            >
              {cat}
            </Text>
          ))}
        </VStack>

        {/* Connect */}
        <VStack align="flex-start" gap={3}>
          <Text fontFamily="'Fraunces', serif" fontWeight={700} mb={1}>Connect</Text>
          {[
            { label: 'Newsletter', path: '/#subscribe' },
            { label: 'Contact', path: '/#contact' },
            { label: 'YouTube', path: 'https://www.youtube.com/@techbheekaran', external: true },
          ].map(link => (
            link.external ? (
              <Link
                key={link.label}
                href={link.path}
                target="_blank"
                color="#6b7fa0"
                fontSize="0.88rem"
                _hover={{ color: '#00c3ff', textDecoration: 'none' }}
              >
                {link.label}
              </Link>
            ) : (
              <Text
                key={link.label}
                color="#6b7fa0"
                fontSize="0.88rem"
                cursor="pointer"
                transition="color 0.2s"
                _hover={{ color: '#00c3ff' }}
                onClick={() => handleNav(link.path)}
              >
                {link.label}
              </Text>
            )
          ))}
        </VStack>
      </Grid>

      <Divider borderColor="rgba(0,195,255,0.1)" mb={6} />

      <Flex
        direction={{ base: 'column', md: 'row' }}
        align={{ base: 'flex-start', md: 'center' }}
        justify="space-between"
        gap={3}
      >
        <Text color="#6b7fa0" fontSize="0.78rem">
          © {new Date().getFullYear()} TechBheekaran. All rights reserved.
        </Text>
        <Box
          display={{ base: 'none', md: 'block' }}
          borderRadius="8px"
          overflow="hidden"
          boxShadow="0 4px 20px rgba(0,0,0,0.4)"
        >
          <Box
            className="g-ytsubscribe"
            data-channelid="UCnM-FxpgB-bf8Y9oBLjjfRQ"
            data-layout="full"
            data-count="default"
          />
        </Box>
      </Flex>
    </Box>
  );
}
